import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useFetch, fileUrl, fmtDate, usePageTitle } from "@/lib/api";
import { Loading, EmptyState, Gallery, VideoEmbed } from "@/components/site/Bits";

export default function ArticleDetail() {
  const { id } = useParams();
  const { data: a, loading, error } = useFetch(`/content/articles/${id}`);
  usePageTitle(a?.title || "Media");
  if (loading) return <div className="wrap pt-40"><Loading /></div>;
  if (error || !a) return <div className="wrap pt-40 pb-20"><EmptyState title="Story not found" testid="article-not-found" /></div>;
  return (
    <article className="bg-pitch pt-32 sm:pt-40 pb-20" data-testid="article-detail-page">
      <div className="wrap max-w-4xl">
        <Link to="/media" className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-400 hover:text-gold" data-testid="article-back-link"><ArrowLeft className="h-4 w-4" /> Media Center</Link>
        <p className="mt-8 eyebrow">{a.category}</p>
        <h1 className="mt-3 h-display text-4xl sm:text-6xl" data-testid="article-title">{a.title}</h1>
        <p className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-slate-400 border-y border-line py-3">By {a.author || "Tri County Allstars"} • {fmtDate(a.date, { month: "long", day: "numeric", year: "numeric" })}</p>
        {a.cover_url && <img src={fileUrl(a.cover_url)} alt="" className="mt-8 w-full aspect-video object-cover" />}
        {a.video_url && <div className="mt-8"><VideoEmbed url={a.video_url} testid="article-video" /></div>}
        <div className="mt-10 space-y-5 text-base sm:text-lg leading-relaxed text-slate-200" data-testid="article-body">
          {(a.body || "").split(/\n\s*\n/).map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>)}
        </div>
        {(a.gallery || []).length > 0 && <div className="mt-12"><Gallery images={a.gallery} testid="article-gallery" /></div>}
      </div>
    </article>
  );
}
